module.exports = __webpack_public_path__ + "static/media/FeedbackBotGrayBackground.8f3d084f.xcf";